import { Dialog, DialogContent, DialogTitle } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { Create, useTranslate } from 'react-admin'
import { FormSpy } from 'react-final-form'
import { injectElement, reduceProps } from '~/helpers'

/*
 * Custom css for dialog
 */
const useStyles = makeStyles({
  scrollPaper: {
    alignItems: 'baseline',
  },
  root: {
    '& div.MuiDialogContent-root': {
      padding: 0,
    },
  },
})

/*
 * CreateModal
 */
const CreateModal = (props: object) => {
  const { fullWidth, title, children, state, open, onClose, ...rest } = props
  const [openState, setOpen] = state || []
  const translate = useTranslate()
  const [dirtyState, setDirtyState] = React.useState(false)

  const handleClose = () => {
    if (dirtyState) {
      if (window.confirm(translate('ra.message.unsaved_changes')))
        state ? setOpen(false) : onClose()
    } else {
      state ? setOpen(false) : onClose()
    }
  }

  const inject = (
    <FormSpy
      subscription={{ dirty: true }}
      onChange={(props) => {
        dirtyState !== props.dirty && setDirtyState(props.dirty)
      }}
    />
  )

  return (
    <Dialog
      // fullWidth={fullWidth}
      open={state ? openState : open}
      onClose={handleClose}
      aria-label={title}
      classes={useStyles()}
      maxWidth='md'
      fullWidth={true}
    >
      <DialogTitle>{translate(title)}</DialogTitle>
      <DialogContent>
        <Create {...reduceProps(rest)} component='div'>
          {injectElement(children, inject, ['SimpleForm', 'FormTab'])}
        </Create>
      </DialogContent>
    </Dialog>
  )
}

export default CreateModal
